

class exports.Layer extends KoModel

    setInitialDeps: () ->
        super()
        @syncDeps(
            'Stage': 'grower::viewmodels/prescription_map/Stage'
        )


    constructor: (parent, data = {}, deps = {}) ->
        super()

        @syncDeps(deps)

        @ignore 'total_acres'

        @parent     = parent

        @id         = data.prescription_map?.id ? null
        @layer_name = ko.observable data.layer?.name ? null
        @layers_id  = data.prescription_map?.layers_id ? null
        @year       = data.layer?.year ? parent.handler.loadLayoutPostOptions.year
        @fields_id  = data.layer?.fields_id ? parent.handler.loadLayoutPostOptions.fields_id
        @base_layer = ko.observable data.prescription_map?.base_layer ? null


        ###
        This is a bit weird, it relies on the stages existing,
        but the stages are the ones who need this value, so they can
        calculate percent acreage.

        To make everything work correctly, we defer this calculation.
        It will run when the children first try to calculate their populations.

        See the Stage.percent_acres calculation to see how the rest
        of this is worked out
        ###
        @total_acres = ko.computed
            read: () =>
                t_acres = 0

                #if @stages?
                for v in @stages
                    t_acres += parseFloat(v.field_soil_acres)

                return t_acres.toFixed(1)

            deferEvaluation: true


        # There should always be stages... but for now i'm leaving this check
        if data.prescription_map_stages?
            stages = $.map data.prescription_map_stages, (item) =>
                return ( new (@getDep 'Stage') this, item )
        else
            stages = [( new (@getDep 'Stage') this )]

        @stages = stages


